import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { CmsConfig, ConfigModule, I18nModule } from "@spartacus/core";
import { MediaModule } from "@spartacus/storefront";
import { CustomProdPgModule } from "../custom-prod-pg/custom-prod-pg.module";
import { NoMouseScrollModule } from "../shared/directives/no-mouse-scroll/no-mouse-scroll.module";
import { CustomPdpComponent } from "./custom-pdp/custom-pdp.component";


@NgModule({
  declarations: [CustomPdpComponent],

  imports: [
    CommonModule,
    MediaModule,
    NgSelectModule,
    I18nModule,

    NgbModule,
    CustomProdPgModule,
    FormsModule,
    NoMouseScrollModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductIntroComponent: {
          component: CustomPdpComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [],
})
export class CustomPdpModule { }
